import * as type from "./types";

export function searchLedger(value, name, cid) {
  return {
    type: type.SEARCH_LEDGER,
    payload: value,
    name,
    cid
  };
}

export function storeLedgerResult(list, name) {
  return {
    type: type.STORE_LEDGER_RESULT,
    payload: list,
    name
  };
}
